import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LoggedOutPage' })(() => ({
  heading: {
    paddingBottom: 'var(--ebl-s3)',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      marginBottom: 'var(--ebl-s2) !important',
    },
  },
}));
